import {
  Counter,
  Label,
  StyledTypes,
  Type,
} from '@/scenes/Gallery/Types/styles';
import { inject, observer } from 'mobx-react';
import { IBearType, IGalleryStore } from '@/stores/Gallery';
import { FC } from 'react';
import Badge from '@/components/Badge';

interface GalleryTypesProps {
  galleryStore: IGalleryStore;
}

const GalleryTypes: FC<any> = ({ galleryStore }: GalleryTypesProps) => {
  const { types, selectType } = galleryStore;

  const onSelectType = (type: IBearType) => {
    selectType(type);
  };

  return (
    <StyledTypes>
      {types.map((type: IBearType) => (
        <Type
          key={type.label}
          active={type.active}
          onClick={() => onSelectType(type)}
          disabled={type.active}
        >
          <Label>{type.label}</Label>
          <Counter>
            <Badge secondary={!type.active}>
              {type.count >= 10000
                ? type.count
                    .toString()
                    .split('')
                    .map((n, i) => {
                      if (i === 1) {
                        return `${n} `;
                      }
                      return n;
                    })
                    .join('')
                : type.count}
            </Badge>
          </Counter>
        </Type>
      ))}
    </StyledTypes>
  );
};

export default inject('galleryStore')(observer(GalleryTypes));
